import { match as category } from "../../../src/params/category.ts";
import { match as lang } from "../../../src/params/lang.ts";
import { match as provider } from "../../../src/params/provider.ts";

export const matchers = { category, lang, provider };